var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterCalendarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 26,
    viewBox: "0 0 23 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.70833 0C7.19158 0 7.58333 0.391751 7.58333 0.875V4.375C7.58333 4.85825 7.19158 5.25 6.70833 5.25C6.22508 5.25 5.83333 4.85825 5.83333 4.375V0.875C5.83333 0.391751 6.22508 0 6.70833 0Z",
    fill: "currentColor",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0417 0C16.5249 0 16.9167 0.391751 16.9167 0.875V4.375C16.9167 4.85825 16.5249 5.25 16.0417 5.25C15.5584 5.25 15.1667 4.85825 15.1667 4.375V0.875C15.1667 0.391751 15.5584 0 16.0417 0Z",
    fill: "currentColor",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.583333 9.14666C0.583333 8.66341 0.975084 8.27166 1.45833 8.27166H21.2917C21.7749 8.27166 22.1667 8.66341 22.1667 9.14666C22.1667 9.62991 21.7749 10.0217 21.2917 10.0217H1.45833C0.975084 10.0217 0.583333 9.62991 0.583333 9.14666Z",
    fill: "currentColor",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.90161 4.82456C2.15409 5.62958 1.75 6.84247 1.75 8.45833V18.375C1.75 19.9909 2.15409 21.2038 2.90161 22.0088C3.63823 22.8021 4.83344 23.3333 6.70833 23.3333H16.0417C17.9166 23.3333 19.1118 22.8021 19.8484 22.0088C20.5959 21.2038 21 19.9909 21 18.375V8.45833C21 6.84247 20.5959 5.62958 19.8484 4.82456C19.1118 4.03128 17.9166 3.5 16.0417 3.5H6.70833C4.83344 3.5 3.63823 4.03128 2.90161 4.82456ZM1.61922 3.63377C2.77844 2.38538 4.49989 1.75 6.70833 1.75H16.0417C18.2501 1.75 19.9716 2.38538 21.1308 3.63377C22.2791 4.87042 22.75 6.5742 22.75 8.45833V18.375C22.75 20.2591 22.2791 21.9629 21.1308 23.1996C19.9716 24.448 18.2501 25.0833 16.0417 25.0833H6.70833C4.49989 25.0833 2.77844 24.448 1.61922 23.1996C0.470906 21.9629 0 20.2591 0 18.375V8.45833C0 6.5742 0.470906 4.87042 1.61922 3.63377Z",
    fill: "currentColor",
    fillOpacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5188 14.525C14.5188 13.8807 15.0412 13.3583 15.6855 13.3583H15.696C16.3403 13.3583 16.8626 13.8807 16.8626 14.525C16.8626 15.1693 16.3403 15.6917 15.696 15.6917H15.6855C15.0412 15.6917 14.5188 15.1693 14.5188 14.525Z",
    fill: "currentColor",
    fillOpacity: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5188 18.025C14.5188 17.3807 15.0412 16.8583 15.6855 16.8583H15.696C16.3403 16.8583 16.8626 17.3807 16.8626 18.025C16.8626 18.6693 16.3403 19.1917 15.696 19.1917H15.6855C15.0412 19.1917 14.5188 18.6693 14.5188 18.025Z",
    fill: "currentColor",
    fillOpacity: 0.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2031 14.525C10.2031 13.8807 10.7254 13.3583 11.3697 13.3583H11.3802C12.0245 13.3583 12.5469 13.8807 12.5469 14.525C12.5469 15.1693 12.0245 15.6917 11.3802 15.6917H11.3697C10.7254 15.6917 10.2031 15.1693 10.2031 14.525Z",
    fill: "currentColor",
    fillOpacity: 0.6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2031 18.025C10.2031 17.3807 10.7254 16.8583 11.3697 16.8583H11.3802C12.0245 16.8583 12.5469 17.3807 12.5469 18.025C12.5469 18.6693 12.0245 19.1917 11.3802 19.1917H11.3697C10.7254 19.1917 10.2031 18.6693 10.2031 18.025Z",
    fill: "currentColor",
    fillOpacity: 0.6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.88503 14.525C5.88503 13.8807 6.40737 13.3583 7.0517 13.3583H7.06218C7.70651 13.3583 8.22884 13.8807 8.22884 14.525C8.22884 15.1693 7.70651 15.6917 7.06218 15.6917H7.0517C6.40737 15.6917 5.88503 15.1693 5.88503 14.525Z",
    fill: "currentColor",
    fillOpacity: 0.6
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.88503 18.025C5.88503 17.3807 6.40737 16.8583 7.0517 16.8583H7.06218C7.70651 16.8583 8.22884 17.3807 8.22884 18.025C8.22884 18.6693 7.70651 19.1917 7.06218 19.1917H7.0517C6.40737 19.1917 5.88503 18.6693 5.88503 18.025Z",
    fill: "currentColor",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterCalendarIcon);
export default __webpack_public_path__ + "static/media/filter-calendar-icon.a761f5210e2cf7a14c2f9a2948d0088c.svg";
export { ForwardRef as ReactComponent };